
import React from 'react';
import { DatePickerWithRange } from '@/components/ui/date-range-picker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { BikeRevenueFiltersProps } from './types';

const BikeRevenueFilters: React.FC<BikeRevenueFiltersProps> = ({
  date,
  setDate,
  selectedModel,
  setSelectedModel,
  availableModels,
  onExport,
  loading
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      <DatePickerWithRange date={date} setDate={setDate} />
      <Select
        value={selectedModel}
        onValueChange={setSelectedModel}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Все модели" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Все модели</SelectItem>
          {availableModels.map(model => (
            <SelectItem key={model} value={model}>{model}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button variant="outline" onClick={onExport} disabled={loading}>
        <Download className="w-4 h-4 mr-2" />
        Экспорт CSV
      </Button>
    </div>
  );
};

export default BikeRevenueFilters;
